import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { ReservationService } from '@app/_components/reservation';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';

@Component({
    selector: 'app-res-select',
    template: `
  <form [formGroup]="reservationSelectForm">
  <p-autoComplete
  [suggestions]="reservationSuggestions"
      [multiple]="true"
      [forceSelection]="false"
      [dropdown]="false"
      [style]="{'width':'100%','padding-bottom':'20px'}"
      [inputStyle]="{'width':'100%'}"
      [minLength]="2"
      formControlName="reservation"
      unique="true"
      field="summary"
      placeholder="Reservation"
      (onSelect)="onSelect($event)"
      (onUnselect)="onUnselect($event)"
      (onKeyUp)="onKeyUp($event)"
      (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
  </form>
`,
    styles: [],
    standalone: false
})
export class ResSelectComponent implements OnInit, OnChanges
{
	texts: string[] = [];
	reservationSuggestions: string[];
	reservationSelectForm: UntypedFormGroup;
	reservation: any;
	taskId: number;

	@Output() messageEvent = new EventEmitter<string>();

	@Input() taskApi: any;






	constructor(
		private formBuilder: UntypedFormBuilder,
		private taskService: TaskService,
		private reservationService: ReservationService,
		private alertService: AlertService) { }

	ngOnInit()
	{
		if (!this.taskId && this.taskApi) { this.taskId = this.taskApi.taskId; }

		// why push into an array you ask?  Because we are using 'multiple=true' on primeng autocomplete with chips
		// becasue I could not get the single to work.  Multiple requires an array, so here it is (even though there will always be just one reservation assigned to a task)
		if (this.taskApi && this.taskApi.reservation)
		{
			// initialize the array (only for primeNG we are using this stupid array)
			this.reservation = [];
			this.reservation.push(this.taskApi.reservation);
		}

		this.reservationSelectForm = this.formBuilder.group({
			reservation: [this.reservation],
			taskId: [this.taskId]
		});
	}

	// for each letter typed in autocomplete...
	onKeyInput(event)
	{
		let query = event.query;
		this.findReservationsWith(query);
		return this.reservationSuggestions;
	}

	// not used.
	onKeyUp(event: KeyboardEvent)
	{
		if (event.key === 'Enter')
		{
			let tokenInput = event.srcElement as any;
			console.log('tokenInput ' + JSON.stringify(tokenInput.value));
			if (tokenInput.value)
			{
				this.reservationSuggestions.push(tokenInput.value);
				tokenInput.value = '';
			}
		}
	}

	onSelect(event)
	{
		if (this.taskId == null)
		{
			
		}
		else
		{
			// assemble the payload manually since we are using primeng
			console.log('onSelect: ' + JSON.stringify(event));
			let data: any = {};
			data.taskId = this.taskId;
			data.reservationId = event.reservationId;
			data.shortTermRentalId = event.shortTermRentalId;
			this.messageEvent.emit(data);
			console.log('onSelect: ' + JSON.stringify(data));
			this.addTaskReservation(data);
		}
	}


	onUnselect(event)
	{
		// assemble the payload manually since we are using primeng
		let data: any = {};
		data.taskId = this.taskId;
		data.reservationId = event.reservationId;
		console.log('onUnselect: ' + JSON.stringify(data));
		this.deleteTaskReservation(data);
	}

	findReservationsWith(queryString: string)
	{
		this.reservationService.findReservationsWith(queryString).pipe(first()).subscribe(

			data =>
			{
				console.log('reservation serach: ' + JSON.stringify(data));
				this.reservationSuggestions = [];
				this.reservationSuggestions = data.data.reservationSummaryList;
				// console.log('QA: ' + JSON.stringify(this.reservationSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	addTaskReservation(reservation)
	{
		this.taskService.updateTaskReservation(reservation).pipe(first()).subscribe(

			data =>
			{
				// console.log('reservations are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	deleteTaskReservation(reservation)
	{
		this.taskService.deleteTaskReservation(reservation).pipe(first()).subscribe(

			data =>
			{
				// console.log('reservations are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	/**
	  *
	  * method to update parent component
	  */


	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.reservationSelectForm !== undefined)
		{
			console.log('taskChange: ' + this.taskApi.taskId);
			this.taskId = this.taskApi.taskId;
			this.reservationSelectForm.patchValue({ taskId: this.taskApi.taskId });
		}
	}
}
